import * as React from 'react';

import { StyledPath } from './IconProps';

export default function HelpIcon(props: { color: string }) {
	return (
		<svg width={24} height={24} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
			<StyledPath
				fillRule="evenodd"
				clipRule="evenodd"
				d="M28.381 56.804c1.189.117 2.394.192 3.618.192 17.674 0 32-12.539 32-28 0-15.464-14.326-28.002-32-28.002C14.326.994 0 13.532 0 28.995c0 8.837 4.69 16.707 11.999 21.838v14.161l16.382-8.19ZM3.999 28.995c0-13.254 12.536-24 28-24S60 15.74 60 28.994c0 13.253-12.537 24-28.001 24-.874 0-1.715-.098-2.557-.197a65.253 65.253 0 0 0-.85-.096L16 58.993v-10.34C8.76 44.313 3.999 37.141 3.999 28.995Zm27.593 4.2c0 .694.393 1.57 1.133 2.093l-2.658 1.18c-1.174-1.006-1.654-2.229-1.654-3.58 0-2.898 2.142-4.4 4.186-5.835 1.868-1.31 3.654-2.563 3.654-4.77 0-2.185-1.698-4.062-5.096-4.062-3.311 0-5.357 1.398-6.969 3.58l-2.178-2.355c2.091-2.749 5.314-4.452 9.451-4.452 5.313 0 8.537 3.011 8.537 6.763 0 3.65-2.578 5.453-4.879 7.062-1.853 1.296-3.527 2.466-3.527 4.375Zm-.61 6.98c-1.306 0-2.396 1.091-2.396 2.4 0 1.31 1.089 2.401 2.396 2.401s2.395-1.09 2.395-2.402c0-1.308-1.089-2.399-2.395-2.399Z"
				color={props.color}
			/>
		</svg>
	);
}
